var _rect, _rect2, _rect3, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeaturesTwoUpholsteredArc3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "232.4px",
    height: "302px",
    viewBox: "0 0 232.4 302",
    enableBackground: "new 0 0 232.4 302",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 37.6,
    fill: "none",
    stroke: "#646463",
    strokeWidth: 1.7568,
    strokeMiterlimit: 10,
    width: 198.4,
    height: 226.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.2,
    y: 51.8,
    fill: "none",
    stroke: "#646463",
    strokeWidth: 1.7321,
    strokeMiterlimit: 10,
    width: 170.1,
    height: 198.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 131.8,
    y: 60.8,
    fill: "#494848",
    width: 0,
    height: 40.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 0.9917,
    strokeMiterlimit: 10,
    d: "M116.6,218.8c0,0,0,2.6-0.4,3.7 c-0.7,1.8,0.5,2.3,0.5,2.3h103.1c0,0,1.1-0.3,0.5-2c-0.4-2.2-0.7-4-0.7-4H116.6L116.6,218.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 0.9917,
    strokeMiterlimit: 10,
    d: "M116.6,213.5c0,0,0.1,1.9-0.4,3.7 c-1.1,2.3,0.5,2.3,0.5,2.3h103.1c0,0,1.1-0.3,0.5-2c-0.4-2.2-0.7-4-0.7-4H116.6L116.6,213.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 0.9917,
    strokeMiterlimit: 10,
    d: "M119.2,10.8H220l-0.3,168.4 c0,0,0.1,1.1,0,4.3c0.5,1.9,1,30.3-0.5,30.3c-1.6,0-97.8,0-101.9,0c-2.9,0-0.9-27.9-1.2-33.7c0-1.4,0-169.2,0-169.2L119.2,10.8 L119.2,10.8z"
  })), /*#__PURE__*/React.createElement("line", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 0.9917,
    strokeMiterlimit: 10,
    x1: 116.1,
    y1: 39.1,
    x2: 219.9,
    y2: 39.1
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 0.9917,
    strokeMiterlimit: 10,
    x1: 116.1,
    y1: 72.7,
    x2: 219.9,
    y2: 72.7
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 0.9917,
    strokeMiterlimit: 10,
    x1: 116.1,
    y1: 108,
    x2: 219.9,
    y2: 108
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 0.9917,
    strokeMiterlimit: 10,
    x1: 116.1,
    y1: 145.2,
    x2: 219.9,
    y2: 145.2
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 0.9917,
    strokeMiterlimit: 10,
    x1: 116.1,
    y1: 181.7,
    x2: 219.9,
    y2: 181.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 0.9917,
    strokeMiterlimit: 10,
    d: "M12.6,181.6c0,0,0,2.6-0.4,3.7 c-0.7,1.8,0.5,2.3,0.5,2.3h103.1c0,0,1.1-0.3,0.5-2c-0.4-2.2-0.7-4-0.7-4H12.6L12.6,181.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 0.9917,
    strokeMiterlimit: 10,
    d: "M12.6,176.3c0,0,0.1,1.9-0.4,3.7 c-1.1,2.3,0.5,2.3,0.5,2.3h103.1c0,0,1.1-0.3,0.5-2c-0.4-2.2-0.7-4-0.7-4H12.6L12.6,176.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 0.9917,
    strokeMiterlimit: 10,
    d: "M15.2,11.2H116l-0.3,130.8 c0,0,0.1,1.1,0,4.3c0.5,1.9,1,30.3-0.5,30.3c-1.6,0-97.8,0-101.9,0c-2.9,0-0.9-27.9-1.2-33.7c0-1.4,0-131.6,0-131.6L15.2,11.2 L15.2,11.2z"
  })), /*#__PURE__*/React.createElement("line", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 0.9917,
    strokeMiterlimit: 10,
    x1: 12.1,
    y1: 39.3,
    x2: 115.9,
    y2: 39.3
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 0.9917,
    strokeMiterlimit: 10,
    x1: 12.5,
    y1: 72.5,
    x2: 116.3,
    y2: 72.5
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 0.9917,
    strokeMiterlimit: 10,
    x1: 12.1,
    y1: 108,
    x2: 115.9,
    y2: 108
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 0.9917,
    strokeMiterlimit: 10,
    x1: 12.1,
    y1: 144.6,
    x2: 115.9,
    y2: 144.6
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesTwoUpholsteredArc3);
export default __webpack_public_path__ + "static/media/FeaturesTwoUpholstered_arc3.748dfadec59fa6d33c14862065c152c9.svg";
export { ForwardRef as ReactComponent };